import * as React from "react";
import {cx} from "emotion";

import "./preview-canvas.scss";

import {cs}        from "@Common/react/chain-services";
import {Repeating} from "@Common/react/repeating";
import {Static2}   from "@Common/react/static-2";
import {chain}     from "@Common/utils/fs";

import {eachPos}         from "../common/each-pos";
import {getColorC}       from "../common/get-color-c";
import {getContainRatio} from "../common/get-contain-ratio";
import {multiplySize}    from "../common/multiply-size";
import {multiplyVector}  from "../common/multiply-vector";
import {fillColors1}     from "../draw-img/fill-colors-1";
import {getImgDataIndex} from "../draw-img/get-img-data-index";

export const PreviewCanvas = ({className, objs, size, ratio: ratio1 = undefined, vpSize}) => cs(
    (_, next) => vpSize && next(),
    ["ref", (_, next) => Static2({next})],
    ({ref}) => {
        const ratio = ratio1 ?? getContainRatio(size, vpSize);

        const vSize = multiplySize(vpSize, ratio);

        return (
            <div {...{
                className: cx("preview-canvas preview-canvas-5nc", className),
                style: {
                    ...size,
                },
            }}>
                <canvas {...{
                    ...vSize,
                    style: {
                        // ...vSize,
                        // ...vpSize.width * ratio < size.width ? {
                        //     top: 0,
                        //     left: (size.width - vpSize.width * ratio) / 2,
                        // } : {
                        //     top: (size.height - vpSize.height * ratio) / 2,
                        //     left: 0,
                        // },
                    },
                    ref: ref.set,
                }}/>
                {Repeating({
                    watchValue: [
                        objs.map((o) => o.renderKey),
                        // omit(image, ["raw"]),
                        vpSize,
                    ],
                    action: () => {
                        const c = ref.get();
                        if (!c) return;

                        const ctx = c.getContext("2d", { willReadFrequently: true });

                        const idTarget = ctx.getImageData(0, 0, c.width, c.height);
                        const getColor = getColorC(objs, {vpSize});
                        if (getColor) {
                            eachPos(c, (p) => {
                                const color = chain(
                                    p,
                                    (_) => multiplyVector(_, 1/ratio),
                                    getColor,
                                );
                                if (!color) {
                                    idTarget.data[getImgDataIndex(p, c.width) + 3] = 0;
                                } else {
                                    fillColors1(color, idTarget.data, getImgDataIndex(p, c.width));
                                }
                            });
                            ctx.putImageData(idTarget, 0, 0);
                        }
                    },
                })}
            </div>
        );
    },
);

